import React from 'react';

const SuccessAlert = ({ isVisible }) => {
    //isVisible = "Visibilidad cambiada correctamente"
    return (
        //create an animated than move from out of the screen to the center with the transform class from tailwind
        <>
            {isVisible && (<div className='fixed right-0 bottom-5 bg-green-400 text-white p-4 z-50 animation-move-right-center flex flex row items-center rounded-2xl'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
                {isVisible}
            </div>)}
        </>

    );
}

export default SuccessAlert;